import "./RippleAnimation.scss";

const RippleAnimation = () => (
    <div class="circles">
        <div class="circle1"></div>
        <div class="circle2"></div>
        <div class="circle3"></div>
    </div>
);

export default RippleAnimation;
